<mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      <mat-icon>menu</mat-icon> My Drive 
    </button>
  </div>
  <div class="d">
    <!-- <button mat-flat-button (click)="showDocDetail()">
      <mat-icon>keyboard_arrow_left</mat-icon> Details
    </button> -->
  </div>
</mat-card>

<div class="coreholder" fxLayout="row">
  <!-- My Drive -->
  <mat-card class="myDrive" [ngClass]="{ open: showmyDrive }">
    <app-left-menu></app-left-menu>
  </mat-card>
  <div
    class="myDriveOverlay"
    (click)="showMyDrive()"
    [ngClass]="{ open: showmyDrive }"
  ></div>
  <!-- My Drive -->

  <!-- Core page Structure -->
  <div class="corepages">
    <!-- Filter -->
    <mat-card class="filter">
      <label>Trash</label>
      <div class="slAct">        
        <button (click)="deleteSentProjects()" *ngIf="SelectedRecordForDeleFav" mat-icon-button><mat-icon>delete_outline</mat-icon></button>
      </div>

      <div class="projectSearch">
      
        <button class="searchbtn" [disabled]="pageModelData.searchValue==''"  mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
       
        <input placeholder="Search Trash" type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
                  
        </div>
      <!-- <mat-form-field appearance="">
        <mat-label>Search... </mat-label>
        <input matInput type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
        <button [disabled]="pageModelData.searchValue==''" matSuffix mat-icon-button aria-label="Clear">
          <mat-icon (click)="SearchFilter()">search</mat-icon>
        </button>
      </mat-form-field> -->

      <!-- <button class="filterbtn" mat-icon-button>
        <mat-icon>filter_list</mat-icon>
      </button> -->

      <!-- <div class="add">
        <button mat-flat-button color="primary" (click)="CreatePdfForm()">Create PDF Form</button>
      </div> -->

      <div class="add">
        <button mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon> Create</button>
        <mat-menu #menu="matMenu">
        <button mat-menu-item  (click)="CreatePdfForm(true)">PDF Form</button>
        <button mat-menu-item  (click)="CreateAuditForm(true)">Tabular Form</button>
        <button mat-menu-item  (click)="CreateHTMLForm(true)">HTML Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreatePdfForm(false)">Master PDF Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateAuditForm(false)">Master Tabular Form</button>
        <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateHTMLForm(false)">Master Web Form</button>
      </mat-menu>       
      </div>

      
    </mat-card>
    <!-- Filter -->

    <mat-card class="emailList">
     
      <mat-table class="zui-table" [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="projectId">
          <div *matHeaderCellDef class="check">
             <mat-checkbox color="primary" [disabled]="noRecordFound"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
          </div>
          <div *matCellDef="let sent" class="check">
            <mat-checkbox color="primary" (change)="isAllSelectedRow($event,sent)"
            (change)="$event ? selection.toggle(sent) : null"
            [checked]="selection.isSelected(sent)"></mat-checkbox>
          </div>
        </ng-container>

        <ng-container matColumnDef="subject">
          <div *matHeaderCellDef mat-sort-header class="subject">
            Subject
          </div>

          <div *matCellDef="let sent" class="subject">
            <h4>{{ sent.subject }}</h4>
          </div> 
        </ng-container>
                 
        <ng-container matColumnDef="trashedDate">
          <div *matHeaderCellDef mat-sort-header class="update">Trashed Date</div>
        
          <p  *matCellDef="let sent" class="update sepDateTime"> 
            <span>{{ sent.trashedDate | date: "MM/dd/yyyy"}}</span>
            <!-- <span class="time" >{{ sent.trashedDate | date: "h:mm a"}}</span> -->
            <span class="time">{{ sent.trashedDate+'Z' | date: "h:mm a" }}</span>
          </p>

        </ng-container>

         

        
        <ng-container matColumnDef="action">
          <div class="action" *matHeaderCellDef>Action</div>

        <div class="action" *matCellDef="let sent">            
          
          <!-- <button color="primary" mat-icon-button (click)="viewDetail(SentProjectDetail,sent)" matTooltipClass="tooltip" matTooltip="View Status">
            <mat-icon>visibility</mat-icon>
          </button> -->

          <!-- <button mat-icon-button matTooltipClass="tooltip" matTooltip="Undo Trash">
            <mat-icon>undo</mat-icon> 
          </button> -->

<!-- 
          <button mat-icon-button class="options" [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
         
          <mat-menu #menu="matMenu"  xPosition="before">
            <button mat-menu-item matTooltipClass="tooltip" matTooltip="Withdraw">
              <mat-icon>stop_circle</mat-icon> Withdraw
            </button>
            <button mat-icon-button matTooltipClass="tooltip" matTooltip="Move to trash" (click)="movetoTrash(sent.projectInboxSentId)" >
              <mat-icon>undo</mat-icon> 
            </button>
          </mat-menu> -->
          

        </div>
        </ng-container>

        <mat-header-row  class="list ehead" *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row  class="list erow"  *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div *ngIf="noRecordFound" class="noRecordFound">No Record Found</div>

      <mat-paginator *ngIf="!noRecordFound" [length]="paginatorTotalLength"
      [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]"
      itemsPerPageLabel="Records Per Page" showFirstLastButtons
      (page)="pageEventPropogate($event)">
      </mat-paginator>
    </mat-card> 

   

  </div>
  <!-- Core page Structure -->

  <!-- Document Detail  -->  
  <mat-card class="documentDetail" [ngClass]="{ open: docDetail }">
    <app-doc-detail></app-doc-detail>
  </mat-card>   
  <!-- Document Detail -->
  
</div>


